export default __webpack_public_path__ + "static/frustrated-employee-illustration-7f68d68aebe2b1b1c42b331a0f7b46ba.png";